import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { Service } from '../../services';
import { GlobalService } from '../../global.service';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-banlist-select',
  templateUrl: './banlist-select.component.html',
  styleUrls: ['./banlist-select.component.sass']
})
export class BanlistSelectComponent implements OnInit {
 
  public postpago;
  public prepago;
  public telefoniaFijo;
  public token:string=sessionStorage.getItem("token");
  @Input() selectBan;
  @Input() currentList;
  @Input() totalAccountList;
  @Output() updateSelectBan = new EventEmitter();
  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService) { }

  ngOnInit() {
  }
  initializeData(mensaje: string){
    this.global.refreshDataTo(this.token);
  }

  refreshDataTo(event:Event) {
    if(this.global.validateSession()===true){
      let index =parseInt(event.target["selectedIndex"]);
      let ban = this.currentList[index].account;
      sessionStorage.setItem("selectBan",btoa(ban));
      this.updateSelectBan.emit(ban);
    }
  }
}
